import { create } from 'zustand';

interface ProcessState {
  processes: API.ASPICEProcess[];
  setProcesses: (p: API.ASPICEProcess[]) => void;
}

export const useProcessStore = create<ProcessState>((set) => ({
  processes: [],
  setProcesses: (processes) => set({ processes }),
}));
